import { Outlet } from "react-router-dom";
import { useContext, useState } from "react";
import AuthContext from "../context/auth/AuthContext";
import Menu from "../components/menu/Menu";
import Navbar from "../components/navbar/Navbar";

import SidebarNavigation from "../components/menu/SidebarNavigation";

const AppLayout = () => {
  const [showNavbar, setShowNavbar] = useState(true);

  const {
    appConfig,
    clearModuleNotice,
    isEmployee,
    moduleNotice,
    modules,
  } = useContext(AuthContext);
  const branding = appConfig?.branding;

  const handleNavbarToggle = () => {
    setShowNavbar(true);
  };

  const handleCloseNavbar = () => {
    setShowNavbar(false);
  };

  return (
    <div className="flex flex-row w-full min-h-screen relative">
      <div className="hidden w-[250px] shrink-0 lg:block">
        <Menu />
      </div>

      <div
        className={`fixed inset-y-0 left-0 z-30 h-screen w-[250px] bg-primary p-4 text-white transition-opacity lg:hidden ${
          showNavbar ? "" : "hidden"
        }`}
      >
        <SidebarNavigation
          branding={branding}
          modules={modules}
          onClose={handleCloseNavbar}
          isEmployee={isEmployee}
        />
      </div>

      <div className={`flex flex-col grow ${showNavbar ? "" : "z-50"}`}>
        <Navbar onNavbarToggle={handleNavbarToggle} />

        <div className="p-8">
          {moduleNotice ? (
            <div
              role="alert"
              className="mb-6 flex items-start justify-between gap-4 rounded border border-amber-200 bg-amber-50 p-4 text-sm text-amber-800"
            >
              <span>{moduleNotice}</span>
              <button
                type="button"
                onClick={clearModuleNotice}
                className="font-semibold underline"
              >
                Dismiss
              </button>
            </div>
          ) : null}
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
